import { SyntheticEvent } from 'react';

import { useGoToAydiAi } from '@/modules/AiAgents/hooks/useGoToAydiAi';
import { useStore } from '@/shared/hooks/context/createGenericContext';

export function useAiClickHandler() {
  const [store] = useStore((s) => s);
  const { redirectToAydiAi } = useGoToAydiAi();

  return (e: SyntheticEvent) => {
    if (!store) return;
    e.preventDefault();
    redirectToAydiAi();

    // old implementation which view Demo popup
    // if (store.isDemoFarm) {
    //   openModal(
    //     <AiDemoModal
    //       onClose={() => {
    //         closeModal();
    //       }}
    //       onConfirm={() => {
    //         router.push(routes.onboarding);
    //         setStore({
    //           asset: store.assetsList?.farms.find((f) => f.id !== -1),
    //           isDemoFarm: false,
    //         });
    //         closeModal();
    //       }}
    //     />,
    //     { dismissable: false }
    //   );
    // } else {
    //   router.push(routes.aydiIntelligence);
    // }
  };
}
